import { Component as ReactComponent } from 'react'
import _ from 'lodash'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  fetchS3Wssid,
  fetchS3Object,
  fetchTempCredential,
  fetchBase64Yimg
} from '../../actions/serviceActions/common'
import { delay } from '../../../lib/renderUtil'
import { importImageAction } from '@vzmi/shp_shared_compo/actions'
import { whiteListedCookie } from '../../../../conf/appConf'

export default function WithS3Service (Component) {
  // eslint-disable-next-line
  class S3ServiceHOC extends ReactComponent {
    getWssId = () => {
      const { fetchS3Wssid } = this.props.s3Service
      const promise = (retry = 1) => fetchS3Wssid()
        .then((res) => {
          if (!res || res.error || _.isEmpty(res.payload)) {
            if (retry >= 3) {
              const e = `取得S3 wssid時失敗，重試${retry}次逾時`
              return Promise.reject(e)
            }
            return delay(500).then(() => promise(retry + 1))
          }
          return res.payload
        })

      return promise()
        .catch((err) => {
          console.error('getWssId', err, err.stack)
          const e = { message: err }
          return Promise.reject(e)
        })
    }

    getCredentials = () => {
      const { fetchTempCredential } = this.props.s3Service
      const fetchTempCredentialPromise = (retry = 1) => fetchTempCredential()
        .then((res) => {
          if (!res || res.error || _.isEmpty(res.payload)) {
            if (retry >= 3) {
              const e = `取得S3憑證時失敗，重試${retry}次逾時`
              return Promise.reject(e)
            }
            return delay(2000).then(() => fetchTempCredentialPromise(retry + 1))
          }
          return res.payload
        })

      return fetchTempCredentialPromise()
        .then((tempCredential) => {
          return {
            accessKeyId: tempCredential.id,
            secretAccessKey: tempCredential.key,
            sessionToken: tempCredential.token
          }
        })
        .catch((err) => {
          console.error('getCredentials', err, err.stack)
          const e = { message: err }
          return Promise.reject(e)
        })
    }

    /** getting the url for uploaded file */
    transformS3Object = (s3FileInfo, file) => {
      const { fetchS3Object } = this.props.s3Service
      const { ETag } = s3FileInfo
      const fetchS3ObjectPromise = (id, retry = 1) => fetchS3Object({ id })
        .then((res) => {
          if (!res || res.error || _.isEmpty(res.payload)) {
            const error = _.get(res, 'payload.errorData.error[0]', {})
            const { code, message: errorMessage } = error
            const allowRetry = code === 4040001
            const retryCount = 30
            if (!allowRetry) {
              const message = `取得S3連結時失敗，訊息: ${errorMessage}.`
              const e = { message }
              return Promise.reject(e)
            }
            if (allowRetry && (retry >= retryCount)) {
              const message = `取得S3連結時失敗，重試${retry}次逾時`
              const e = { message }
              return Promise.reject(e)
            }
            return delay(3000).then(() => fetchS3ObjectPromise(id, retry + 1))
          }
          return res.payload
        })

      return fetchS3ObjectPromise(ETag)
        .then((s3Object) => {
          if (s3Object) {
            return _.merge(s3FileInfo, s3Object)
          } else {
            const message = '取得S3連結時失敗'
            const e = { message }
            return Promise.reject(e)
          }
        })
    }

    /*
   * 呼叫reservice, 把外站的圖片網址轉換成內部圖片網址
   * 外站的圖片下載, 與S3上傳在server處理
   * service會回傳S3 FileInfo, 剩下在client/browser呼叫 transformS3Object 自行去抓取s.yimg.com的圖片網址
  */
    convertToS3Image = imgUrl => {
      const { importImageAction } = this.props.s3Service
      return importImageAction({ imgUrl, whiteListedCookie }).then((res) => {
        return res.payload
      }).catch(error => {
        console.error('convertToS3Image', error, error.stack)
      })
    }

    render () {
      return (
        <Component
          {...this.props}
          getWssId={this.getWssId}
          getCredentials={this.getCredentials}
          transformS3Object={this.transformS3Object}
          convertToS3Image={this.convertToS3Image}
        />
      )
    }
  }

  const mapStateToProps = (state, ownProps) => {
    return {}
  }

  const mapDispatchToProps = (dispatch) => {
    const actions = {
      fetchS3Wssid,
      fetchS3Object,
      fetchTempCredential,
      importImageAction,
      fetchBase64Yimg
    }

    return {
      s3Service: {
        ...bindActionCreators(actions, dispatch)
      }
    }
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(S3ServiceHOC)
}
